import React from "react";
import { useDispatch, useSelector } from "react-redux";
import boardsSlice from "../redux/boardsSlice";
import API from "../api";

export default function Subtask({ index, taskIndex, colIndex }) {
  const dispatch = useDispatch();
  const boards = useSelector((state) => state.boards);
  const board = boards.find((board) => board.isActive === true);
  const col = board.columns.find((col, i) => i === colIndex);
  const task = col.tasks.find((task, i) => i === taskIndex);
  const subtask = task.subtasks.find((subtask, i) => i === index);
  const checked = subtask.isCompleted;

  const onChange = async (e) => {
    let updatedBoard = JSON.parse(JSON.stringify(board));
    const subtaskToUpdate = updatedBoard.columns[colIndex].tasks[taskIndex].subtasks[index];
    subtaskToUpdate.isCompleted = !subtaskToUpdate.isCompleted;

    try {
      await API.put(`/boards/${board._id}`, updatedBoard);
      const res = await API.get("/boards");
      dispatch(boardsSlice.actions.setBoards(res.data));
    } catch (err) {
      console.error(err);
    }
  };

  return (
    <div className="subtask">
      <input
        className="subtask-checkbox"
        type="checkbox"
        checked={checked}
        onChange={onChange}
      />
      <p className={`subtask-text text-M ${checked && "checked"}`}>
        {subtask.title}
      </p>
    </div>
  );
}
